module.exports = __webpack_public_path__ + "static/coworkHotdesk-c5ef814dfaba090be4099a6f7f1e53bb.jpg";